import RestModel from "discourse/models/rest";

export default class FilterRule extends RestModel {
  group_id = -1;
  reward_list = "";
}
